import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import Logo from './Logo';

function Navbar() {
  const { user } = useAuth();

  return (
    <header className="bg-white shadow p-2 py-3 flex items-center justify-between fixed top-0 left-0 w-full z-50 px-6">
      <div />
      <div className="absolute left-1/2 transform -translate-x-1/2 text-6xl font-bold text-gray-900">
        <Link to="/">
          <Logo />
        </Link>
      </div>
      {user && (
        <div className="flex items-center gap-2 z-10">
          {user.logo_url ? (
            <img
              src={user.logo_url}
              alt=""
              className="w-8 h-8 rounded-full"
              referrerPolicy="no-referrer"
            />
          ) : (
            <div className="w-8 h-8 rounded-full bg-slate-300 flex items-center justify-center text-sm font-bold text-white">
              {(user.firstname || user.email || '?')[0].toUpperCase()}
            </div>
          )}
          <span className="text-sm text-slate-600 hidden sm:inline">
            {user.firstname} {user.lastname}
          </span>
        </div>
      )}
    </header>
  );
}

export default Navbar;
